import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Booking {
  id: string;
  date: string;
  type: string;
  year: number;
  week_number: number;
  [key: string]: any;
}

interface BookingsState {
  items: Booking[];
  loading: boolean;
  error: string | null;
}

const initialState: BookingsState = {
  items: [],
  loading: false,
  error: null,
};

const bookingsSlice = createSlice({
  name: 'bookings',
  initialState: initialState,
  reducers: {
    getBookings: (state, action: PayloadAction<{ page: number }>) => {
      return state;
    },
    getBookingsFailed: (state) => {
      return state;
    },
    updateBookingStates: (state, action: PayloadAction<any>) => {
      // Handle booking state updates
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase('getBookings', (state) => {
      state.loading = true;
    });

    builder.addCase('GET_BOOKINGS_COMMIT', (state, action: PayloadAction<{ bookings: Booking[] }>) => {
      const { bookings } = action.payload;
      const { meta } = action as any;

      const isPagedRequest = meta && meta.page !== undefined && meta.page > 0;

      state.loading = false;

      if (isPagedRequest) {
        if (bookings && bookings.length > 0) {
          state.items = [...state.items, ...bookings];
        }
      } else {
        state.items = bookings ? [...bookings] : [];
      }
    });

    builder.addCase('bookings/getBookingsFailed', (state) => {
      state.loading = false;
    });
  },
});

export const {
  getBookings: getBookingsSlice,
  getBookingsFailed,
  updateBookingStates,
} = bookingsSlice.actions;

// Action types are now properly configured for Redux Offline

export default bookingsSlice.reducer;

// Redux Offline action creators
export const getBookings = (data: { page: number }) => {
  const action = {
    type: 'getBookings',
    payload: data,
    meta: {
      offline: {
        effect: {
          url: `/bookings?page=${data.page}`,
          method: 'GET'
        },
        commit: { type: 'GET_BOOKINGS_COMMIT', meta: { page: data.page } },
        rollback: { type: getBookingsFailed.type },
      }
    }
  };
  // Action properly configured with Redux Toolkit action types
  return action;
};